import * as actions from './apartment-detail.actions';
import watch from './apartment-detail.operations';
import reducer, { initState } from './apartment-detail.reducers';

export { actions, watch, initState };

export default reducer;
